import { FC } from 'react';

import { Icon, LinkButton, LinkButtonProps } from '@eluve/components';

type OpenInAdminButtonProps = {
  appointmentId: string;
  tenantId: string;
  size?: LinkButtonProps['size'];
};

export const OpenInAdminButton: FC<OpenInAdminButtonProps> = ({
  appointmentId,
  tenantId,
  size,
}) => {
  const url = `/admin/organizations/${tenantId}/appointments/${appointmentId}`;

  return (
    <LinkButton variant="outline" size={size} to={url}>
      <Icon name="ShieldCheck" size="auto" />
      Open in Admin Dashboard
    </LinkButton>
  );
};
